module.exports = __webpack_public_path__ + "img/hero-air-04.3ab99e9f.png";